import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";
import { showApiErrorToast } from "../../utils/toastErrorHandler";

export async function teamListApi(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.team.list}`, {
    params,
  });
}

export async function teamMembersApi(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.team.members}`, {
    params,
  });
}

export async function teamFlowApi(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.team.flow}`, {
    params,
  });
}

/* Lives in the team module rather than the dashboard one even though the
   route is /dashboard/team-wise: everything that reads tbl_Team is here, and
   splitting it would mean two slices caching team names. */
export async function teamWiseApi(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.dashboard.teamWise}`, {
    params,
  });
}

export async function taskTimelineApi(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.team.timeline}`, {
    params,
  });
}

/* Hand a task to another team, or to another person in the same team.
   The server answers 400 with the reason when the move is not allowed
   ("A task cannot go straight from Support to Testing.") — that message is
   the whole point of the call failing, so it is surfaced rather than
   swallowed into a generic error. */
export async function moveTaskApi(payload) {
  try {
    const response = await api.post(apiPath.team.move, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Move Task Error:", error);
    throw showApiErrorToast(error.response?.data);
  }
}

export async function setUserTeamsApi(payload) {
  try {
    const response = await api.put(apiPath.team.userTeams, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Set User Teams Error:", error);
    throw showApiErrorToast(error.response?.data);
  }
}

export async function designationsApi() {
  try {
    const response = await api.get(apiPath.team.designations);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
}

export async function setUserDesignationApi(payload) {
  try {
    const response = await api.post(apiPath.team.designation, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
}

export async function setTeamMemberManagerApi(payload) {
  try {
    const response = await api.post(apiPath.team.memberManager, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
}

export async function upsertTeamMemberApi(payload) {
  try {
    const response = await api.post(apiPath.team.member, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Team Member Save Error:", error);
    throw showApiErrorToast(error.response?.data);
  }
}

/* Create a team, or rename one by including teamCode. Admin only server-side. */
export async function upsertTeamApi(payload) {
  return await api.post(`${apiPath.API_URL}${apiPath.team.upsert}`, payload);
}

/* The whole ordered list of team codes: { teamCodes: [3, 1, 4, 2] }. */
export async function reorderTeamsApi(payload) {
  return await api.put(`${apiPath.API_URL}${apiPath.team.order}`, payload);
}
